<div class="side-menu px-3">
  <ng-container *ngIf="environment.products['kbin']">
    <button class="add-button" (click)="createNewChat()">
      <mat-icon>add</mat-icon><span>New chat</span>
    </button>
    <ul>
      <li *ngFor="let chat of chats">
        <app-chat-title
          [subscription_id]="subscription_id"
          [conversation_id]="chat.conversation_id"
          [title]="chat.title"
          (newChatDeletionEvent)="handleChatDeletion($event)"
        ></app-chat-title>
      </li>
    </ul>
  </ng-container>
  <!-- <app-shortify [controls]="formJson" *ngIf="environment.products.shortify"></app-shortify> -->
  <!-- <app-bizbrain [controls]="formJson" *ngIf="environment.products.bizbrain"></app-bizbrain> -->
  <app-bizbrain
    [subscription_id]="subscription_id"
    *ngIf="environment.products['bizbrain']"
    (displayResponse)="displayResponse($event)"
    (clearResponse)="clearResponse($event)"
    [response]="response"
  ></app-bizbrain>
  <app-deep-process
    [subscription_id]="subscription_id"
    *ngIf="environment.products['deepProcess']"
    (displayResponse)="displayResponse($event)"
  ></app-deep-process>
  <app-estimate
    [subscription_id]="subscription_id"
    [response]="response"
    *ngIf="environment.products['estimate']"
    (displayResponse)="displayResponse($event)"
  ></app-estimate>
  <app-planit
    [subscription_id]="subscription_id"
    *ngIf="environment.products['planit']"
    (displayResponse)="displayResponse($event)"
  ></app-planit>
  <!-- <app-kbin
    [subscription_id]="subscription_id"
    *ngIf="environment.products['kbin']"
    (displayResponse)="displayResponse($event)"
  ></app-kbin> -->
  <app-postgenie
    [subscription_id]="subscription_id"
    *ngIf="environment.products['postgenie']"
    (displayResponse)="displayResponse($event)"
  ></app-postgenie>
  <app-shortify
    [subscription_id]="subscription_id"
    *ngIf="environment.products['shortify']"
    (displayResponse)="displayResponse($event)"
  ></app-shortify>
  <app-iqgen
    [subscription_id]="subscription_id"
    *ngIf="environment.products['iqgen']"
    (displayResponse)="displayResponse($event)"
  ></app-iqgen>
</div>
